import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        type:
        {
            type: String,
            default: 'bar' // bar, image
        },

        size:
        {
            type: String,
            default: 'small',
        },

        width:
        {
            type: String,
            default: '100%'
        },

        height:
        {
            type: String,
        },

        shape:
        {
            type: String,
            default: null
        },

        divClass:
        {
            type: String,
            default: '',
        }
    },

    render()
    {
        return h(
            'div',
            {

                class:
                [
                    'vh-placeholder',
                    `vh-placeholder-${this.type}`,
                    `vh-placeholder-${this.type}-${this.size}`,
                    'vh-animate',
                    'vh-animate-infinite',
                    'vh-animate-shimmer',
                    this.divClass,
                ],
                
                style:
                {
                    width: this.width,
                    height: this.height,
                },
            }
        );
    },
};
